import React from 'react';
import { Grid, Box } from '@material-ui/core';
import {
  FieldLabelText,
  SummaryItemContainer,
  SummaryIconWrapper,
} from '../UserRequestsStyles';
import { SummaryItemConfig } from '../types';

interface SummaryRequestViewProps {
  items: SummaryItemConfig[];
}

const SummaryItem: React.FC<SummaryItemConfig> = ({ icon, label, value }) => (
  <SummaryItemContainer>
    <SummaryIconWrapper>{icon}</SummaryIconWrapper>
    <Box>
      <FieldLabelText>{label}</FieldLabelText>
      <Box>{value}</Box>
    </Box>
  </SummaryItemContainer>
);

const SummaryRequestView: React.FC<SummaryRequestViewProps> = ({
  items,
}) => {
  return (
    <Grid container>
      {items.map((item, index) => (
        <Grid key={index} item xs={12} md={3}>
          <SummaryItem icon={item.icon} label={item.label} value={item.value} />
        </Grid>
      ))}
    </Grid>
  );
};

export default SummaryRequestView;
